import { useEffect } from "react";
import { QueryClientProvider } from "@tanstack/react-query";
import { RouterProvider } from "react-router";
import { queryClient } from "@/lib/queryClient";
import { setUnauthorizedHandler } from "@/lib/api";
import { router } from "@/router";

export function App() {
  useEffect(() => {
    // A 401 anywhere in the app clears the token and forces a hard reload to /login. A hard
    // reload (rather than router navigation from outside a component) is deliberate: it also
    // resets every in-memory query and socket, so a session that just expired can never leave
    // stale authenticated data on screen.
    setUnauthorizedHandler(() => {
      if (window.location.pathname !== "/login") window.location.assign("/login");
    });
  }, []);

  return (
    <QueryClientProvider client={queryClient}>
      <RouterProvider router={router} />
    </QueryClientProvider>
  );
}
